import { useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';
import { MonthlyCalendar } from '@/components/plan-matriz/monthly-calendar';

export function PlanMatrizMonthlyPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full -m-3 md:-m-6">
      {/* Compact header */}
      <div className="flex items-center justify-between px-3 py-2 md:px-4 shrink-0">
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => { void navigate('/plan-matriz'); }}
            className="p-1.5 rounded-lg text-sime-text-tertiary hover:text-sime-text-primary transition-colors"
            aria-label="Volver"
          >
            <ArrowLeft className="h-4 w-4" />
          </button>
          <h1 className="text-base font-bold text-sime-text-primary">
            Vista Mensual
          </h1>
        </div>
        <button
          type="button"
          onClick={() => { void navigate('/plan-matriz'); }}
          className="text-xs font-medium text-sime-accent hover:underline"
        >
          Ver Lista
        </button>
      </div>

      {/* Calendar fills remaining space */}
      <div className="flex-1 min-h-0 px-2 pb-2 md:px-3 md:pb-3">
        <MonthlyCalendar />
      </div>
    </div>
  );
}
